// @flow

/**
 * Module dependencies.
 */

import { Col, Row } from 'client/components/core/grid';
import { Select } from 'client/components/core/forms';
import { colors, defaultTransition, media, states, units } from 'client/styles';
import { position, size } from 'polished';
import Icon from 'client/components/core/icon';
import React, { Component } from 'react';
import Text from 'client/components/core/type';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  fromCurrency: string,
  fromCurrencyList: Array<Object>,
  inputChange: Function,
  labelFrom: string,
  labelTo: string,
  swithCurrencies: Function,
  toCurrency: string,
  toCurrencyList: Array<Object>
};

/**
 * `LinkExchange` component.
 */

const LinkExchange = styled.span`
  ${size(units(4), units(4))};

  color: ${colors.brandPrimary};
  cursor: pointer;
  display: inline-block;
  opacity: 1;
  position: relative;
  top: ${units(3.2)};
  transition: opacity ${defaultTransition};

  ${states.interaction`
    opacity: .7;
  `}
`;

/**
 * `ToOrFromCurrency` styled component.
 */

const ToOrFromCurrency = styled.div`
  border-bottom: 1px solid ${colors.shadesOfBlue.regentGray};
  padding: 5px 0 3px ${units(1)};
  text-align: left;

  ${media.min.xs`
    padding-left: ${units(2)};
  `};
`;

/**
 * `Flag` component.
 */

const Flag = styled.img`
  ${size(units(3), units(3))};

  ${media.max.xs`
    ${size(units(2.5), units(2.5))};
  `};
`;

/**
 * `SelectFlag` component.
 */

const SelectFlag = styled(Flag)`
  ${position('absolute', null, null, '9px', '9px')};

  ${media.min.xs`
    left: 17px;
  `};

  ${media.max.xs`
    bottom: 11px;
  `};
`;

/**
 * `CurrencyWrapper` styled component.
 */

const CurrencyWrapper = styled.div`
  align-items: center;
  column-gap: 10px;
  display: flex;
`;

/**
 * `CurrencyLabel` styled component.
 */

// $FlowFixMe
const CurrencyLabel = styled(Text.H4)`
  color: ${colors.shadesOfBlue.oxfordBlue};
  margin: 0;
`;

/**
 * `SelectWrapper` component.
 */

const SelectWrapper = styled.div`
  display: block;
  position: relative;
`;

/**
 * `CurrencySelect` component.
 */

const CurrencySelect = styled(Select)`
  padding-left: 45px;

  ${media.min.xs`
    padding-left: 50px;
  `};

  ${media.max.xs`
    padding-left: 34px;
  `};
`;

/**
 * `CurrenciesFromTo` component.
 */

class CurrenciesFromTo extends Component {

  /**
   * Props.
   */

  props: Props;

  /**
   * Render select currency.
   */

  renderSelectCurrency = (
    label: string,
    name: string,
    options: Array<Object>,
    value: string
  ): React$Element<*> => {
    const { inputChange } = this.props;

    if (options.length === 1) {
      const [currency] = options;

      return (
        <ToOrFromCurrency>
          <Text.Small
            color={colors.shadesOfBlue.regentGray}
            weight={700}
          >
            {label}
          </Text.Small>

          <CurrencyWrapper>
            <Flag src={require(`client/assets/images/flags/${currency.value}.png`)} />

            <CurrencyLabel>
              {currency.label}
            </CurrencyLabel>
          </CurrencyWrapper>
        </ToOrFromCurrency>
      );
    }

    return (
      <SelectWrapper>
        <SelectFlag src={require(`client/assets/images/flags/${value}.png`)} />

        <CurrencySelect
          label={label}
          name={name}
          onChange={inputChange}
          options={options}
          value={value}
        />
      </SelectWrapper>
    );
  }

  /**
   * Render.
   */

  render(): React$Element<*> {
    const {
      fromCurrency,
      fromCurrencyList,
      labelFrom,
      labelTo,
      swithCurrencies,
      toCurrency,
      toCurrencyList
    } = this.props;

    return (
      <Row>
        <Col xs={5}>
          {this.renderSelectCurrency(labelFrom, 'fromCurrency', fromCurrencyList, fromCurrency)}
        </Col>

        <Col xs={2}>
          <LinkExchange onClick={swithCurrencies}>
            <Icon
              icon={'exchange'}
              size={units(4)}
            />
          </LinkExchange>
        </Col>

        <Col xs={5}>
          {this.renderSelectCurrency(labelTo, 'toCurrency', toCurrencyList, toCurrency)}
        </Col>
      </Row>
    );
  }

}

/**
 * Export `CurrenciesFromTo`.
 */

export default CurrenciesFromTo;



// WEBPACK FOOTER //
// ../src/client/components/forms/components/currencies-from-to.js